/**
 * Session Goal Templates
 * Used by SessionGoalManager to generate daily goals
 */

import { SessionGoalType } from '@/types';

export interface SessionGoalTemplate {
  type: SessionGoalType;
  descriptionTemplate: string;
  targetRange: [number, number];
  baseRewardGold: number;
  baseRewardXP: number;
  rewardPerTarget: number;
  useSpecies?: boolean;
  useQuality?: boolean;
}

export const SESSION_GOAL_TEMPLATES: SessionGoalTemplate[] = [
  // 1. Catch N fish (any)
  {
    type: SessionGoalType.CATCH_FISH,
    descriptionTemplate: 'Catch {count} fish',
    targetRange: [5, 15],
    baseRewardGold: 20,
    baseRewardXP: 10,
    rewardPerTarget: 4,
  },
  // 2. Catch N of a specific species
  {
    type: SessionGoalType.CATCH_SPECIES,
    descriptionTemplate: 'Catch {count} {species}',
    targetRange: [3, 8],
    baseRewardGold: 30,
    baseRewardXP: 15,
    rewardPerTarget: 8,
    useSpecies: true,
  },
  // 3. Catch a quality+ fish (Rare or above)
  {
    type: SessionGoalType.CATCH_QUALITY,
    descriptionTemplate: 'Catch {count} {quality}+ fish',
    targetRange: [1, 3],
    baseRewardGold: 50,
    baseRewardXP: 25,
    rewardPerTarget: 40,
    useQuality: true,
  },
  // 4. Earn gold from selling
  {
    type: SessionGoalType.EARN_GOLD,
    descriptionTemplate: 'Earn {count}g from selling',
    targetRange: [50, 200],
    baseRewardGold: 25,
    baseRewardXP: 10,
    rewardPerTarget: 0.15,
  },
  // 5. Sell N fish
  {
    type: SessionGoalType.SELL_FISH,
    descriptionTemplate: 'Sell {count} fish',
    targetRange: [5, 15],
    baseRewardGold: 20,
    baseRewardXP: 10,
    rewardPerTarget: 3,
  },
  // 6. Hit N sweet spots
  {
    type: SessionGoalType.SWEET_SPOT_HITS,
    descriptionTemplate: 'Hit {count} sweet spots',
    targetRange: [3, 10],
    baseRewardGold: 30,
    baseRewardXP: 15,
    rewardPerTarget: 5,
  },
  // 7. Catch N of an uncommon+ species (bigger target)
  {
    type: SessionGoalType.CATCH_SPECIES,
    descriptionTemplate: 'Catch {count} {species}',
    targetRange: [2, 5],
    baseRewardGold: 50,
    baseRewardXP: 20,
    rewardPerTarget: 15,
    useSpecies: true,
  },
  // 8. Catch an Epic+ fish
  {
    type: SessionGoalType.CATCH_QUALITY,
    descriptionTemplate: 'Catch an Epic+ fish',
    targetRange: [1, 1],
    baseRewardGold: 100,
    baseRewardXP: 50,
    rewardPerTarget: 100,
    useQuality: true,
  },
  // 9. Catch a big haul (many fish, high target)
  {
    type: SessionGoalType.CATCH_FISH,
    descriptionTemplate: 'Catch {count} fish',
    targetRange: [10, 25],
    baseRewardGold: 40,
    baseRewardXP: 20,
    rewardPerTarget: 3,
  },
  // 10. Sell for a big sum
  {
    type: SessionGoalType.EARN_GOLD,
    descriptionTemplate: 'Earn {count}g from selling',
    targetRange: [100, 400],
    baseRewardGold: 40,
    baseRewardXP: 20,
    rewardPerTarget: 0.1,
  },
  // 11. Set and pull traps
  {
    type: SessionGoalType.PULL_TRAPS,
    descriptionTemplate: 'Set and pull {count} traps',
    targetRange: [2, 4],
    baseRewardGold: 30,
    baseRewardXP: 15,
    rewardPerTarget: 10,
  },
  // 12. Catch crustaceans from traps
  {
    type: SessionGoalType.CATCH_CRUSTACEANS,
    descriptionTemplate: 'Catch {count} crustaceans from traps',
    targetRange: [3, 8],
    baseRewardGold: 35,
    baseRewardXP: 15,
    rewardPerTarget: 8,
  },
];
